var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveToInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1111 8H16.8444C11.9111 8 8 12 8 16.8889V79.1111C8 84 11.9111 88 16.8444 88H79.1111C84 88 88 84 88 79.1111V16.8889C88 12 84 8 79.1111 8ZM79.1111 59.8333C79.1111 60.6618 78.4395 61.3333 77.6111 61.3333H65.2C63.1111 61.3333 61.4222 62.8444 60.8444 64.8889C59.2889 70.5333 54.0889 74.6667 48 74.6667C41.9111 74.6667 36.7111 70.5333 35.1556 64.8889C34.5778 62.8444 32.8889 61.3333 30.8 61.3333H18.3444C17.516 61.3333 16.8444 60.6618 16.8444 59.8333V21.3333C16.8444 18.8889 18.8444 16.8889 21.2889 16.8889H74.6667C77.1111 16.8889 79.1111 18.8889 79.1111 21.3333V59.8333ZM63.2256 41.6703C64.1685 40.7248 63.4988 39.1111 62.1635 39.1111H58.3889C57.5605 39.1111 56.8889 38.4395 56.8889 37.6111V27.2778C56.8889 26.4493 56.2173 25.7778 55.3889 25.7778H40.6111C39.7827 25.7778 39.1111 26.4494 39.1111 27.2778V37.6111C39.1111 38.4395 38.4395 39.1111 37.6111 39.1111H33.8435C32.5072 39.1111 31.8379 40.7268 32.7829 41.6718L46.4444 55.3333C47.3333 56.2222 48.7111 56.2222 49.6 55.3333L63.2256 41.6703Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveToInbox);
export default __webpack_public_path__ + "static/media/move_to_inbox.e286e6c7075aa20871bdae501b79dc4b.svg";
export { ForwardRef as ReactComponent };